import {
  ProductDetailsResponseDto,
  ProductCreateRequestDto,
  ProductCreateRequestApiV2Dto,
  i18nResponseDto,
  VariantRequestDto,
  VariantRequestApiV2Dto,
  InventoryLevelsResponse,
} from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';

function attributesArrayToMap(
  language: LanguagesType,
  attributes: i18nResponseDto[] = [],
) {
  return attributes.reduce((acc, attribute, index) => {
    const key = (index + 1).toString();
    acc[key] = {
      ...attribute,
      default: attribute[language],
    };
    return acc;
  }, {} as Record<string, i18nResponseDto>);
}

function variantRequestDtoToDtoV2(
  language: LanguagesType,
  variants: VariantRequestDto[] = [],
): VariantRequestApiV2Dto[] {
  return variants.map((variant) => ({
    price: variant.price,
    inventoryLevels: getInventoryLevels(variant.inventory_levels),
    attributes: attributesArrayToMap(language, variant.values),
  }));
}

function getInventoryLevels(inventoryLevels: InventoryLevelsResponse[] = []) {
  return inventoryLevels.map((inventoryLevel) => ({
    locationId: inventoryLevel.location_id,
    stock: inventoryLevel.stock,
  }));
}

export function createResponseDto(
  createdId: number,
): ProductDetailsResponseDto {
  return { id: createdId } as unknown as ProductDetailsResponseDto;
}

export function requestDtoToRequestDtoV2(
  product: ProductCreateRequestDto,
  language: LanguagesType,
): ProductCreateRequestApiV2Dto {
  const { name, description, handle, published, attributes, variants } =
    product;

  const defaultName = name[language];

  return {
    name: {
      ...name,
      default: defaultName,
    },
    description: description
      ? { ...description, default: description[language] }
      : { default: '' },
    publish: published ? 1 : 0,
    attributes: attributesArrayToMap(language, attributes),
    variants: variantRequestDtoToDtoV2(language, variants),
    handle: handle ?? { default: defaultName },
    categories: product.categories?.map((category) => Number(category)) ?? [],
  };
}
